<template>
  <div>
    <div class="java110_step">
      <el-steps :active="addStaffStepInfo.index" finish-status="success">
        <el-step title="选择分公司"></el-step>
        <el-step title="选择部门"></el-step>
        <el-step title="员工信息"></el-step>
      </el-steps>
    </div>

    <!-- 选择应用信息 -->
    <div v-if="addStaffStepInfo.index == 0 || addStaffStepInfo.index == 1">
      <view-org-info 
        ref="viewOrgInfo"
        :callBackListener="'addStaffStep'"
        :callBackFunction="'notify'"
      ></view-org-info>
    </div>

    <div v-show="addStaffStepInfo.index == 2">
      <add-staff-view
        ref="addStaffView"
        :callBackListener="'addStaffStep'"
        :callBackFunction="'notify'"
      ></add-staff-view>
    </div>

    <el-row>
      <el-col :span="22" :offset="2">
        <div class="action-buttons">
          <el-button type="info" @click="_prevStep()">上一步</el-button>
          <el-button 
            v-if="addStaffStepInfo.index != 2" 
            type="primary" 
            @click="_nextStep()"
          >下一步</el-button>
          <el-button 
            v-if="addStaffStepInfo.index == 2" 
            type="primary" 
            @click="_finishStep()"
          >完成</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ViewOrgInfo from '@/components/frame/viewOrgInfo/viewOrgInfo.vue'
import AddStaffView from '@/components/frame/addStaffView/addStaffView.vue'
import { bindingStaff } from '@/api/frame/addStaffStepApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddStaffStep',
  components: {
    ViewOrgInfo,
    AddStaffView
  },
  data() {
    return {
      addStaffStepInfo: {
        index: 0,
        infos: [],
        branchOrgInfo: {
          orgId: '',
          componentName: '分公司信息',
          buttonName: '选择分公司',
          orgName: '',
          orgLevel: '2',
          parentOrgId: '',
          description: '',
        },
        departmemtOrgInfo: {
          orgId: '',
          componentName: '部门信息',
          buttonName: '选择部门',
          orgName: '',
          orgLevel: '3',
          parentOrgId: '',
          description: '',
        },
        staffInfo: {
          orgId: '',
          username: '',
          sex: '',
          email: '',
          tel: '',
          address: '',
          relCd: '',
          photo: ''
        }
      }
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(this.shopId)
  },
  methods: {
    _prevStep() {
      if (this.addStaffStepInfo.index > 0) {
        this.addStaffStepInfo.index--
        this.$refs.viewOrgInfo.updateIndex(this.addStaffStepInfo.index)
        this.$refs.addStaffView.updateIndex(this.addStaffStepInfo.index)
        this._notifyViewOrgInfoComponentData()
      }
    },
    _nextStep() {
      const currentData = this.addStaffStepInfo.infos[this.addStaffStepInfo.index]
      if (!currentData) {
        this.$message.warning('请选择或填写必选信息')
        return
      }
      
      if (this.addStaffStepInfo.index < 2) {
        this.addStaffStepInfo.index++
        this.$refs.viewOrgInfo.updateIndex(this.addStaffStepInfo.index)
        this.$refs.addStaffView.updateIndex(this.addStaffStepInfo.index)
        this._notifyViewOrgInfoComponentData()
      }
    },
    async _finishStep() {
      const currentData = this.addStaffStepInfo.infos[this.addStaffStepInfo.index]
      if (!currentData) {
        this.$message.warning('请选择或填写必选信息')
        return
      }

      try {
        const res = await bindingStaff(this.addStaffStepInfo.staffInfo)
        if (res.code === 0) {
          this.$message.success('处理成功')
          this.$router.go(-1)
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('请求失败:', error)
        this.$message.error(error.message || '处理失败')
      }
    },
    _notifyViewOrgInfoComponentData() {
      if (this.addStaffStepInfo.index === 0) {
        this.$refs.viewOrgInfo.initInfo(this.addStaffStepInfo.branchOrgInfo)
      } else if (this.addStaffStepInfo.index === 1) {
        this.addStaffStepInfo.departmemtOrgInfo.parentOrgId = 
          this.addStaffStepInfo.branchOrgInfo.orgId
        this.$refs.viewOrgInfo.initInfo(this.addStaffStepInfo.departmemtOrgInfo)
      }
    }
  },
  mounted() {
    this.$on('addStaffStep', 'notify', (info) => {
      if (this.addStaffStepInfo.index === 0) {
        Object.assign(this.addStaffStepInfo.branchOrgInfo, info)
        this.addStaffStepInfo.infos[0] = this.addStaffStepInfo.branchOrgInfo
      } else if (this.addStaffStepInfo.index === 1) {
        Object.assign(this.addStaffStepInfo.departmemtOrgInfo, info)
        this.addStaffStepInfo.staffInfo.orgId = info.orgId
        this.addStaffStepInfo.infos[1] = this.addStaffStepInfo.departmemtOrgInfo
      } else {
        Object.assign(this.addStaffStepInfo.staffInfo, info)
        this.addStaffStepInfo.infos[2] = this.addStaffStepInfo.staffInfo
      }
    })
  }
}
</script>

<style scoped>
.java110_step {
  margin-bottom: 20px;
}
.action-buttons {
  margin-bottom: 10px;
  text-align: right;
}
</style>